import { useEffect, useState } from 'react';

import { Capacitor } from '@capacitor/core';

let initialized = false;

export function useGoogleAuth() {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const initGoogleAuth = async () => {
      const platform = Capacitor.getPlatform();
      const isNative = platform === 'android' || platform === 'ios';
      const webClientId =
        (import.meta as any)?.env?.VITE_GOOGLE_WEB_CLIENT_ID ||
        (import.meta as any)?.env?.VITE_GOOGLE_NATIVE_CLIENT_ID ||
        '538686134191-9ir6ibcj18agfo44u4rmt2o29jh7bmm2.apps.googleusercontent.com';

      if (platform === 'android' && !initialized) {
        try {
          console.log('[useGoogleAuth] Initializing Google Auth plugin...');
          const { GoogleAuth } = await import('@codetrix-studio/capacitor-google-auth');

          await GoogleAuth.initialize({
            clientId: webClientId,
            scopes: ['profile', 'email'],
            grantOfflineAccess: true,
          });

          initialized = true;
          console.log('[useGoogleAuth] ✅ Google Auth plugin initialized');
          setIsReady(true);
        } catch (error) {
          console.error('[useGoogleAuth] ❌ Failed to initialize Google Auth:', error);
          setIsReady(false);
        }
      } else if (platform === 'ios') {
        // iOS: usamos @capacitor-firebase/authentication (nativo). No inicializar Codetrix.
        setIsReady(true);
      } else if (!isNative) {
        // En web no necesita inicialización
        setIsReady(true);
      } else {
        // Ya está inicializado
        setIsReady(true);
      }
    };

    initGoogleAuth();
  }, []);

  return { isReady };
}
